import roundedButtonStyle from 'styles/buttons/rounded-button.module.scss';
import React, { FC, useState } from 'react';
import { DialogWrapper } from 'components/shared/dialog';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Dialog, Grid } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Input } from 'components/shared/input';
import { postCustomCTA } from 'adapters';
import { useDispatch, useSelector } from 'react-redux';
import { GetUrlBuilderData, SetUrlBuilderData } from 'store/url-builder';
import { useParams } from 'react-router-dom';
import { DialogHeader } from 'components/shared/dialog/dialog-header';
import portfolio_free from 'assets/portfolio_free.png';

const schema = yup.object().shape({
//  buttonText: yup.string().required().label('Button Name'),
//  buttonLink: yup.string().required().label('URL'),
});

export interface PublishDialogProps {
 isOpen: boolean;
 onClose(result: string): void;
 builderType: string;
}

export const PublishDialog: FC<PublishDialogProps> = ({ isOpen, onClose, builderType }) => {
 const dispatch = useDispatch();
 const builderData = useSelector(GetUrlBuilderData);
 const [loading, setLoading] = useState(false);
 const { cardId }: {cardId: string} = useParams(); 
 const [fullScreen, setFullScreen] = useState(false);

 const buySubcription = () => {
  onClose('SUBSCRIBE');
  window.open('/pro/index/profile', '_top');
 };

 const publishAnyway = () => {   
   onClose('PUBLISH');
 }

 return (
  <Dialog open={isOpen} fullScreen={false} maxWidth={'md'}>
    <Grid container item xs={12} style={{ margin: 0, padding: '.5em 1em'}} spacing={3} justifyContent='center'>
      <Grid item xs={12}>
        <DialogHeader title={''} onClose={onClose} enableFullScreen={fullScreen} fullScreen={false} setFullScreen={setFullScreen} />
      </Grid>
      <Grid item container xs={12} style={{alignItems:'center'}}>
        <Grid item xs={4}>
            <img src={portfolio_free} />
        </Grid>
        <Grid item xs={8} style={{display: 'flex', alignItems: 'flex-start', textAlign: 'left'}} direction="column">
          <p>Congratulations on designing your digital business card!</p>
          <p> As a Free plan member, 
            after publishing your card it will look similar to the example on the left. 
            To unlock more amazing L-Card features such as the video and image gallery, testimonials, 
            calls-to-action button, and lead generator, consider upgrading to our all-inclusive Pro plan.
          </p>
          <p><span style={{fontStyle: 'italic', fontWeight:'bold', fontSize:'14px'}}>"L-Card is an application that I highly recommend at a price that simply can't be beat."</span><br/>
          <span style={{fontSize:'14px'}}>- Howell Silverman, Keller Williams Commercial.</span>
          </p>
        </Grid>
      </Grid>
      <Grid item xs={12} container>
        <Grid item xs >
          <Button
            onClick={publishAnyway}
            className={roundedButtonStyle.root}
            variant='contained'
            style={{ backgroundColor: '#aaa', borderColor: '#aaa', color: '#fff' }}
            // 35bb35
            >             
            Proceed with publish
          </Button>
        </Grid>
        <Grid item xs style={{ justifyContent: "flex-end", display: 'flex'}}>
          <Button
            onClick={buySubcription}
            className={roundedButtonStyle.root}
            variant='contained'
            style={{ backgroundColor: '#35bb35', borderColor: '#35bb35', color: '#fff' }}
            // fb3535
            >
            Try Or Buy Subscription Now
          </Button>
        </Grid>
      </Grid>
    </Grid>
  </Dialog>
 );
};
